import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';
import { Router } from '@angular/router';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { UploadsModel } from 'src/app/models/upload/uploads.model';
import { UploadsService } from 'src/app/service/uploads.service';
import { Subscription } from 'rxjs';
import { extractApiErrorMessage } from '../upload-template.util';

@Component({
  selector: 'app-template-create',
  templateUrl: './template-create.component.html',
  styleUrls: ['./template-create.component.css']
})
export class TemplateCreateComponent implements OnInit, OnDestroy {

  public uploadsModel1 = new UploadsModel();
  public columnsList: UploadsModel[];
  public selectedUserDoc: UploadsModel[] = [];
  public loggedinUser = '';
  private subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private uploadsService: UploadsService,
    public ete: ExportExcelService,
    private authGaurdService: AuthGaurdService,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.loggedinUser = this.authGaurdService.loginUser();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  redirect(url: string): void {
    this.router.navigate(['/' + url]);
  }

  downloadExcelHeaders(): void {
    if (!this.uploadsModel1.recordname) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please enter record name');
      return;
    }
    this.subscriptions.push(
      this.uploadsService.getRecordsList(this.uploadsModel1.recordname).subscribe(
        (response: UploadsModel[]) => {
          this.ete.exportHeaderOnlyTemplate('Template', response);
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, extractApiErrorMessage(errorResponse));
        }
      )
    );
  }

  public insertTemplate(): void {
    if (!this.uploadsModel1.recordname) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please enter record name');
    } else if (!this.uploadsModel1.recordtemplate) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please enter record template');
    } else {
      for (const updatePlan of this.columnsList) {
        updatePlan.recordname = this.uploadsModel1.recordname;
        updatePlan.recordtemplate = this.uploadsModel1.recordtemplate;
        updatePlan.recorddesc = this.uploadsModel1.recorddesc;
        updatePlan.created_by = this.loggedinUser;
        this.selectedUserDoc.push(updatePlan);
      }
      this.subscriptions.push(
        this.uploadsService.saveTemplate(this.selectedUserDoc).subscribe(
          () => {
            this.notificationService.sendNotification(NotificationType.SUCCESS, 'Added successfully');
            this.selectedUserDoc = [];
          },
          (errorResponse: HttpErrorResponse) => {
            this.notificationService.sendNotification(NotificationType.ERROR, extractApiErrorMessage(errorResponse));
          }
        )
      );
    }
  }

  public getColumns(): void {
    if (!this.uploadsModel1.recordtemplate) {
      return;
    }
    this.subscriptions.push(
      this.uploadsService.getColumnsList(this.uploadsModel1.recordtemplate).subscribe(
        (res: UploadsModel[]) => {
          this.columnsList = res;
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, extractApiErrorMessage(errorResponse));
        }
      )
    );
  }

  trackByColumnIndex(index: number): number {
    return index;
  }
}
